import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Slider from 'react-slick'
import persons from '../persons.js'

import HoverBox from '../components/styled/HoverBox'

import PrevArrow from '../components/PrevArrow'
import NextArrow from '../components/NextArrow'

export default class ReactComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      slider: {
        coverWidth: 10,
        offset: 100,
        topOffset: 13,
      },
      currentSlide: 0,
      displaySlider: false
    }
    this.getElementContentWidth = this.getElementContentWidth.bind(this)
    this.setFixedSlider = this.setFixedSlider.bind(this);
  }
  startSlideTimeout() {
      this.timeout = setTimeout(() => {
        if (this.slider) {
          this.slider.slickNext()
        }
        if (typeof window !== 'undefined') {
          this.startSlideTimeout()
        }
      }, 3000)
  }
  endSlideTimeout() {
      clearTimeout(this.timeout)
  }
  setSlider() {
    if (this.props.location.pathname === '/') {
      this.startSlideTimeout()
    } else {
      this.endSlideTimeout()
    }
  }
  slideChange(currentSlide) {
    this.setState({
      currentSlide
    })
  }
  getElementContentWidth = (element) => {
    var styles = window.getComputedStyle(element);
    var padding = parseFloat(styles.paddingLeft) +
                  parseFloat(styles.paddingRight);

    return element.clientWidth - padding;
  }
  propTypes () {
    return {
      children: React.PropTypes.any
    }
  }
  setFixedSlider = () => {
    const coverWidth = this.getElementContentWidth(document.getElementById('container'))
    const offset = (document.body.clientWidth - coverWidth) / 2
    const topOffset = document.getElementById('container').offsetTop
    this.setState({
      slider: {
        coverWidth,
        offset,
        topOffset
      }
    })
    return true
  }
  componentWillReceiveProps(nextProps) {
    if (location.pathname === '/') {
      this.setState({
        currentSlide: 0
      })
    }
  }
  componentDidMount() {
    this.setSlider()
    this.setFixedSlider()
    window.addEventListener("resize", this.setFixedSlider.bind(this));
    this.setState({displaySlider: true})
  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.setFixedSlider.bind(this));
  }
  render() {
    const onHome = this.props.location.pathname === '/'

    const sliderSettings = {
      lazyLoad: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      beforeChange: (prevSlide, slide) => {this.slideChange(slide)},
      initialSlide: 0
    }

    const slides = (persons || []).map(person => {
      const {coverWidth, offset, topOffset} = this.state.slider
      const yOffset = coverWidth > 600 ? person.yOffset : 0
      const imgStyle = {
        backgroundImage:`url("${person.original}")`,
        height: '350px',
        backgroundAttachment: onHome ? 'scroll' : 'fixed',
        backgroundSize: onHome ? 'cover' : coverWidth - 14,
        backgroundPositionX: onHome ? '' : offset + 7,
        backgroundPositionY: onHome ? -topOffset - 7 - yOffset : 0 - yOffset,
        backgroundRepeat: 'no-repeat',
      }

      const name = person.name

      if (onHome || this.props.location.pathname === person.path) {
        return (<div key={person.name}><Link style={{textDecoration: 'none', cursor: onHome ? 'pointer' : 'default'}} to={prefixLink(person.path)}><div style={imgStyle}></div><div style={{
          padding: '1.1rem 2rem',
          marginLeft: 'auto',
          marginTop: '-2.8rem',
          zIndex: '0',
          backgroundColor: 'white',
          marginRight: '5vw',
          color: person.color,
          position: 'relative',
          display: 'inline-block',
          float: 'right'
        }}>
          <h1 style={{margin: '0', fontSize: '2.5em'}}>{name}</h1>
        </div></Link></div>)
      }
    }).filter(item => {
      return item !== undefined
    })

    let slider = null;
    if (onHome) {
      slider = <Slider ref={(Slider) => { this.slider = Slider }} {...sliderSettings}>{slides}</Slider>
    } else {
      slider = slides
    }
    const personColor = onHome ? persons[this.state.currentSlide].color : this.props.routes[this.props.routes.length - 1].page.data.color
    return (
      <div style={{height: this.state.displaySlider ? 'inherit' : 'calc(399px + 3rem)'}}>
        <HoverBox color={personColor} style={{marginBottom: '5vh', display: this.state.displaySlider ? 'block' : 'none'}}>
          {slider}
        </HoverBox>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../components/Carousel.js